import { render, staticRenderFns } from "./basic-tread-value.vue?vue&type=template&id=1b7a5772&scoped=true&"
import script from "./basic-tread-value.vue?vue&type=script&lang=ts&"
export * from "./basic-tread-value.vue?vue&type=script&lang=ts&"
import style0 from "./basic-tread-value.vue?vue&type=style&index=0&id=1b7a5772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a5772",
  null
  
)

export default component.exports